export default __webpack_public_path__ + "static/media/PrescriptionApp-card-logo.6bc2837c.png";